var _desc, _defs, _g, _clipPath, _clipPath2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkIgnitionOffDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "97418e35-1836-422a-9cde-7b2b1b3f419f"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "b1c113fd-504b-40c7-b550-be571878f664"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(54 0 0 54 540 540)",
    id: "Vector",
    clipPath: "url(#CLIPPATH_3)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_3"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 0 0)",
    id: "clip0_349_1422",
    x: -10,
    y: -10,
    rx: 0,
    ry: 0,
    width: 20,
    height: 20
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(199,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-10, -10)",
    d: "M 10 20 C 15.5228 20 20 15.5228 20 10 C 20 4.47715 15.5228 0 10 0 C 4.47715 0 0 4.47715 0 10 C 0 15.5228 4.47715 20 10 20 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(54 0 0 54 540 540)",
    id: "Vector_2",
    clipPath: "url(#CLIPPATH_4)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_4"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 0 0)",
    id: "clip0_349_1422",
    x: -10,
    y: -10,
    rx: 0,
    ry: 0,
    width: 20,
    height: 20
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-10, -10)",
    d: "M 10.7668 8.95902 L 10.7668 4.12593 C 10.7654 3.92354 10.684 3.72993 10.5404 3.58732 C 10.3967 3.44471 10.2025 3.36469 10.0001 3.36469 C 9.79774 3.36469 9.60355 3.44471 9.45992 3.58732 C 9.3163 3.72993 9.23488 3.92354 9.23344 4.12593 L 9.23344 8.95902 C 9.23488 9.16141 9.3163 9.35502 9.45992 9.49763 C 9.60355 9.64023 9.79774 9.72026 10.0001 9.72026 C 10.2025 9.72026 10.3967 9.64023 10.5404 9.49763 C 10.684 9.35502 10.7654 9.16141 10.7668 8.95902 Z M 16.6406 9.99999 C 16.6405 11.1637 16.3346 12.3069 15.7536 13.3152 C 15.1725 14.3234 14.3367 15.1613 13.3299 15.7448 C 12.3231 16.3283 11.1807 16.637 10.017 16.64 C 8.85329 16.643 7.70925 16.3401 6.69947 15.7617 C 5.6897 15.1834 4.84963 14.3498 4.26344 13.3445 C 3.67725 12.3393 3.36552 11.1976 3.35946 10.0339 C 3.35341 8.87026 3.65326 7.72543 4.22897 6.71413 C 4.80467 5.70282 5.63602 4.86056 6.63973 4.27171 C 6.75755 4.20258 6.89155 4.16579 7.02815 4.16506 C 7.16476 4.16433 7.29914 4.19968 7.4177 4.26755 C 7.53626 4.33542 7.6348 4.43339 7.70335 4.55155 C 7.7719 4.66972 7.80803 4.80389 7.80809 4.9405 C 7.80809 5.24167 7.69035 5.48433 7.42711 5.63999 C 6.66961 6.08832 6.04181 6.72604 5.60543 7.49048 C 5.16905 8.25493 4.9391 9.11977 4.9382 9.99999 C 4.9382 12.7912 7.20914 15.0619 10 15.0619 C 12.7909 15.0619 15.0622 12.7912 15.0622 9.99999 C 15.0612 9.11977 14.8313 8.25495 14.3949 7.49051 C 13.9585 6.72608 13.3308 6.08835 12.5733 5.63999 C 12.4561 5.5728 12.3589 5.47551 12.2919 5.35818 C 12.2249 5.24085 12.1905 5.10775 12.1922 4.97265 C 12.1922 4.66769 12.3138 4.42144 12.5826 4.26738 C 12.7006 4.19782 12.8352 4.16151 12.9722 4.16228 C 13.1091 4.16306 13.2433 4.2009 13.3605 4.27179 C 14.3584 4.85864 15.1859 5.69574 15.7612 6.70036 C 16.3364 7.70498 16.6396 8.84233 16.6406 9.99999 Z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkIgnitionOffDisabled);
export default __webpack_public_path__ + "static/media/dark_ignition_off_disabled.deaa6497adfca31b186c0c954996fc76.svg";
export { ForwardRef as ReactComponent };